import { css } from '@emotion/react'
import { AnimationProps } from 'framer-motion'
import { FLOW_STEPS } from 'share/types'

export const baseUrl = import.meta.env.VITE_BASE_URL
export const baseWsUrl = import.meta.env.VITE_BASE_WS_URL
export const ModeApp = import.meta.env.MODE
export const notaryUrl = import.meta.env.VITE_NOTARY_URL
export const recaptchaSitekey = import.meta.env.VITE_RECAPTCHA_SITEKEY
export const yandexMapApi = import.meta.env.VITE_YANDEX_MAP_API
export const geoguesserApi = import.meta.env.VITE_YANDEX_GEOGUESSER_API
export const q19CallTopic = import.meta.env.VITE_Q19_CALL_TOPIC

export const STEPS_WITH_MANUAL_RESOLUTION = [FLOW_STEPS.FETCH_DDOCS, FLOW_STEPS.APPROVE_PROPERTY_PLEDGES]

export const LS_LANG_KEY = 'lang'

export const pathnames = Object.freeze({
  all: '*',
  index: '/',
  calculator: '/calculator',
  'create-lead': '/create-lead',
  'scoring-loader': '/scoring-loader',
  'prescoring-loader': '/prescoring-loader',
  rejected: '/rejected',
  biometry: '/biometry',
  decision: '/decision',
  notary: '/notary',
  'upgrade-conditions': '/upgrade-conditions',
  'documents-sign': '/documents-sign',
  'certification-center': '/certification-center',
  'repayment-schedule-sign': '/repayment-schedule-sign',
  'digital-doc': '/digital-doc',
  'own-debt': '/own-debt',
  'internal-step-loader': '/internal-step-loader',
  'open-borrower-account': '/open-borrower-account',
  'damu-countdown': '/damu-countdown',
  'damu-verification': '/damu-verification',
  'damu-second-confirmation': '/damu-second-confirmation',
  'spouse-confirmation': 'spouse-confirmation',
  'q19-call': '/q19-call',
  'pledge-documents-upload': '/pledge/documents-upload',
  'pledge-fee-payment': '/pledge/comission-payment',
  retry: '/retry',
  success: '/success'
})

export const APP_STEPS = [
  {
    step: 1,
    title: 'flow-ip-info',
    apiStep: [
      FLOW_STEPS.FETCH_PERSONAL_INFO,
      FLOW_STEPS.CHECK_DECISION_IIN,
      FLOW_STEPS.GENERATE_DOCUMENTS_SIGNED_BY_OTP,
      FLOW_STEPS.COLVIR_CHECK_IF_CORP_CARD_ALREADY_CREATED,
      FLOW_STEPS.CREATE_APPLICATION_IN_TELEMARKETING
    ]
  },
  {
    step: 2,
    title: 'flow-info-check',
    apiStep: [
      FLOW_STEPS.PRE_SCORE,
      FLOW_STEPS.BIOMETRY_AITU,
      FLOW_STEPS.BIOMETRY_FORENSICS,
      FLOW_STEPS.SCORING,
      FLOW_STEPS.UPDATE_LOAN_DATA_IN_TELEMARKETING,
      FLOW_STEPS.FETCH_PKB_REPORT,
      FLOW_STEPS.FETCH_JUR_INFO,
      FLOW_STEPS.UPLOAD_UL_DATA_IN_TELEMARKETING,
      FLOW_STEPS.PROPERTY_PLEDGES,
      FLOW_STEPS.APPROVE_PROPERTY_PLEDGES
    ]
  },
  {
    step: 3,
    title: 'flow-application',
    apiStep: [
      FLOW_STEPS.DECISION,
      FLOW_STEPS.UPDATE_LOAN_DATA_IN_TELEMARKETING,
      FLOW_STEPS.FETCH_DDOCS,
      FLOW_STEPS.CHECK_TAX_DEBT,
      FLOW_STEPS.OPEN_FL_CARD,
      FLOW_STEPS.OPEN_UL_CARD,
      // Damu steps
      FLOW_STEPS.CHECK_ELICENSE,
      // pledge steps
      FLOW_STEPS.CHECKING_COLLATERAL,
      FLOW_STEPS.CREATE_ESTIMATION,
      FLOW_STEPS.AWAITING_CREDIT_MANAGER_DECISION,
      FLOW_STEPS.DECISION_LAWYER,
      FLOW_STEPS.DECISION_COLLATERAL,
      FLOW_STEPS.PAYBOX_COMISSION_FEE_PAYMENT,
      FLOW_STEPS.DECISION_ESTIMATOR,
      FLOW_STEPS.GENERATE_CONCLUSION_ON_COLLATERAL,
      FLOW_STEPS.COLVIR_MORTGAGE,
      FLOW_STEPS.DOCUMENT_SIGNING_AND_VERIFICATION,
      FLOW_STEPS.SEND_PLEDGE_AGREEMENTS_CLIENT_SIGNATURE_TO_CRED_ADMIN,
      // own auto steps
      FLOW_STEPS.GENERATE_OPENING_ACCOUNT_DOCUMENTS,
      FLOW_STEPS.SEND_BANK_DATA_TO_CRED_ADMIN,
      FLOW_STEPS.SEND_LOAN_DATA_TO_CRED_ADMIN,
      // notary steps
      FLOW_STEPS.CHOOSING_NOTARY,
      FLOW_STEPS.DECISION_NOTARY,
      //
      FLOW_STEPS.OPEN_BORROWER_ACCOUNT,
      FLOW_STEPS.UPLOAD_BANK_DATA_IN_TELEMARKETING,
      FLOW_STEPS.SET_PAY_DAY,
      FLOW_STEPS.GET_CORP_CARD_DATA,
      FLOW_STEPS.REGISTER_IN_COLVIR,
      FLOW_STEPS.GENERATE_MAIN_DOCUMENTS,
      FLOW_STEPS.GENERATE_DOCUMENTS_SIGNED_BY_ECP,
      FLOW_STEPS.CREATE_APPLICATION_IN_CRED_ADMIN,
      FLOW_STEPS.WAIT_FOR_CONFIRMATION_FROM_CRED_ADMIN
    ]
  },
  {
    step: 4,
    title: 'flow-doc-sign',
    apiStep: [
      FLOW_STEPS.SIGN_DOCS_AITU,
      FLOW_STEPS.SIGN_BANK_LOAN_AGREEMENT_BY_BANK,
      // Damu steps
      FLOW_STEPS.DAMU_CREATE_APPLICATION,
      FLOW_STEPS.DAMU_OBLIGATION_CHECK,
      FLOW_STEPS.REGISTER_IN_COLVIR_DAMU_PROGRAM,
      FLOW_STEPS.GENERATE_REPAYMENT_SCHEDULE,
      FLOW_STEPS.CREATE_MORTGAGE,
      FLOW_STEPS.SEND_ADDITIONAL_DOCUMENTS_TO_CRED_ADMIN,
      FLOW_STEPS.SECOND_CONFIRMATION_FROM_CRED_ADMIN,
      FLOW_STEPS.SIGN_REPAYMENT_SCHEDULE_WITH_AITU,
      // pledge steps
      FLOW_STEPS.SIGN_DOCS_AITU_PLEDGE,
      FLOW_STEPS.SIGN_PLEDGE_AGREEMENT_BY_BANK,
      FLOW_STEPS.BLOCKCHAIN_CREATE_RECORD,
      // pledge steps end
      FLOW_STEPS.SIGN_REPAYMENT_SCHEDULE_BY_BANK,
      FLOW_STEPS.LOAN_ACTUALIZE
    ]
  }
]

export const UpdateConditionsModalTexts: {
  [key: string | number]: {
    title: string
    text: string
  }
} = {
  TAX_FORM: {
    title: 'Налоговая форма 910 за 2 налоговых периода',
    text: 'В зависимости от выбранной формы налогового режима вам необходимо предоставить одну из следующих форм за 2 налогового периода (год/полугодие/квартал)'
  },
  BVU: {
    title: 'Выписка БВУ',
    text: 'Данные по выписке из БВУ должны быть за последние 12 месяцев в формате PDF'
  },
  OBV: {
    title: 'Оборотно-сальдовая ведомость',
    text: 'Оборотно-сальдовая ведомость (ОСВ) — бухгалтерский документ, в котором показаны остатки по счетам за последние 12 месяцев, а также оборот вашей компании по дебету и кредиту. Данные по ОСВ необходимо загрузить в формате PDF'
  }
}

export const conditionBlockStyles = css`
  &:nth-of-type(n + 3) {
    border-top: 1px solid var(--grey-stroke);
  }
  &:nth-of-type(even) {
    border-left: 1px solid var(--grey-stroke);
  }
  &:nth-of-type(odd):last-child {
    grid-column: span 2;
    border-top: 1px solid var(--grey-stroke);
  }
`

export const gradiendBorderStyles = css`
  &:before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 20px;
    padding: 1px;
    opacity: 0;
    background: linear-gradient(45deg, rgba(32, 181, 83), rgba(32, 181, 83, 0.2), rgba(32, 181, 83));
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    transition: opacity 0.3s ease;
  }
  &:hover:before {
    opacity: 1;
  }
`

export const stepsInitAnimation: AnimationProps['initial'] = {
  y: '100vh',
  opacity: 0
}

export const stepsExitAnimation: AnimationProps['exit'] = {
  y: '-100vh',
  opacity: 0,
  transition: {
    duration: 0.6
  }
}

export const cardInitAnimation: AnimationProps['initial'] = {
  y: '100vh'
}

export const cardExitAnimation: AnimationProps['exit'] = {
  y: '-100%',
  transition: {
    duration: 0.6
  }
}

export const stepsAnimationVariants: AnimationProps['variants'] = {
  popIn: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 1,
      delay: 0.6
    }
  },
  rotateProgress: {
    rotate: 90,
    transition: {
      delay: 1.7,
      duration: 4.6
    }
  },
  cardPopIn: {
    y: 40,
    transition: {
      delay: 3
    }
  }
}
